export default "__VITE_ASSET__889Xr_o6__"